export const zIndex = {
  negative: -1,
  neutral: 0,
  layer: 1,
  elevated: 2,
  overlay: 7,
  globe: 8,
  headingImage: 9,
  signupModal: 10,
  navigation: 11,
  header: 12,
  high: 9997,
  modal: 9998,
  regionSelectModal: 9999,
  mobileMenu: 9999,
  loader: 10000,
} as const;
